import { UiEvent } from '../utils/ui-event';

export class ClickTracking {
	constructor() {
		const buttons: NodeListOf<HTMLElement> = document.querySelectorAll(
			'.wp-element-button[data-bi-subcategory][data-bi-target-id], .wp-block-image>a[data-bi-subcategory][data-bi-target-id], .wp-block-details > summary[data-bi-subcategory][data-bi-target-id]'
		);

		buttons.forEach((button: HTMLElement) => {
			button.addEventListener(
				'click',
				(event: Event) => {
					const target: HTMLElement = event.target as HTMLElement;

					UiEvent.trackUIEvent(
						target.dataset.biSubcategory,
						target.dataset.biTargetId,
						event.type
					);
				},
				{ once: true }
			);
		});
	}
}
